import React, { useState, useRef, useEffect, useContext } from 'react';
import { Button, Input, Label, Modal, ModalBody, ModalHeader, Spinner, UncontrolledTooltip } from 'reactstrap';
import {
  faAddressCard,
  faCalendarAlt,
  faIdCardAlt,
  faUserAlt,
  faUserEdit,
  faUsers,
  faCalendarDay,
  faUserCheck,
  faCoffee,
  faListUl,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

import style from './style';
import { fetchDataAgnostic } from '../../../../../../Services/dataApi';
import { CSVLink } from 'react-csv';
import { DepartmentContext } from '../../../../../../DepartmentWrapper';
import { checkLoginForError, formatBearerToken } from '../../../../../../Common.functions';
import { useAuth0 } from '../../../../../../auth0/reactAuth0Spa';
import { toast } from 'react-toastify';

import { createPDFForSchedule } from '../../../../../../Services/PDFMakeTemplates/MasterSchedule';
import Swal from 'sweetalert2';
import Schedule from '../..';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { createPDFForCandidateBadges } from '../../../../../../Services/PDFMakeTemplates/CandidateBadges/CandidateBadges';
import { createPDFForCandidateBadges2 } from '../../../../../../Services/PDFMakeTemplates/CandidateBadges/CandidateBadges_avery_5384';
import { createPDFForCandidateFactCards } from '../../../../../../Services/PDFMakeTemplates/CandidateBadges/CandidateFactCards';
import { createPDFForCandidateFaces } from '../../../../../../Services/PDFMakeTemplates/CandidateBadges/CandidateFaces';
import { createPDFForEvaluatorSchedule } from '../../../../../../Services/PDFMakeTemplates/EvaluatorSchedule/EvaluatorSchedule';
import { createPDFForCandidateSchedule } from '../../../../../../Services/PDFMakeTemplates/CandidateSchedule/CandidateSchedule';
import { createPDFForCandidateFacesWithNotes } from '../../../../../../Services/PDFMakeTemplates/CandidateBadges/CandidateFacesWithNotes';
import { separateDataTypesByAvailability } from '../../../../../../Services/candidates';
import { createPDFForCandidatesBreakReport } from '../../../../../../Services/PDFMakeTemplates/CandidateBreakReports/CandidateBreakReport';
import { createPDFForCandidateEvaluations } from '../../../../../../Services/PDFMakeTemplates/CandidateEvaluations/CandidateEvaluations';
import Loading from 'Body/Statuses/Loading';
import { clone } from 'lodash';
import PdfPreviewModal from '../PdfPreviewModal';

// Configure PDF.js worker (using local worker bundled with the app)
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

// Initialize Day.js plugins
dayjs.extend(utc);
dayjs.extend(timezone);

const PrintDropDown = ({
  scheduleID,
  row = {},
  setShowSettings,
  department,
  setIsShowingSchedulePreview,
  forcedScheduleData,
  isScheduleInitialized = true,
}) => {
  const candidateCSVDownload = useRef();
  const scheduleRef = useRef();

  const [candidateCSVData, setCandidateCSVData] = useState([]);
  const [scheduleData, setScheduleData] = useState();
  const [columnTracker, setColumnTracker] = useState();
  const [rowTracker, setRowTracker] = useState();
  const [candidates, setCandidates] = useState();

  const [isDownloadingCandidates, setIsDownlaodingCandidates] = useState(false);
  const [isProcessingPDF, setIsProcessingPDF] = useState(false);
  const [pdfProgress, setPdfProgress] = useState({ current: 0, total: 0 });

  const [showSchedulePreview, setShowSchedulePreview] = useState(false);
  const [schedulePreviewDataURL, setSchedulePreviewDataURL] = useState();
  const [numPages, setNumPages] = useState(null);
  const [showPdfPreviewModal, setShowPdfPreviewModal] = useState(false);
  const [pdfPreviewUrl, setPdfPreviewUrl] = useState(null);
  const [pdfPreviewTitle, setPdfPreviewTitle] = useState('');
  const [pdfPreviewFileName, setPdfPreviewFileName] = useState('');

  const [PDFOrientation, setPDFOrientation] = useState('landscape');
  const [PDFFontSize, setPDFFontSize] = useState(4);
  const [dataTypes, setDataTypes] = useState([]);

  const [isPreparingScheduleData, setIsPreparingScheduleData] = useState(true);

  const dContext = useContext(DepartmentContext);
  const { getTokenSilently, loginWithRedirect } = useAuth0();

  useEffect(() => {
    if (candidateCSVData && candidateCSVData.length > 0) {
      setTimeout(() => {
        candidateCSVDownload.current.link.click();
      }, 1000);

      setTimeout(() => {
        setCandidateCSVData([]);
        if (setShowSettings) {
          setShowSettings(false);
        }
      }, 2000);
    }
  }, [candidateCSVData]);

  useEffect(() => {
    getDepartmentDataTypes((newDataTypes) => {
      const separatedDataTypes = separateDataTypesByAvailability(newDataTypes);
      setDataTypes(separatedDataTypes.enabled);
    });
  }, []);

  useEffect(() => {
    if (forcedScheduleData) {
      // Breaks the system
      // setScheduleData(forcedScheduleData);
    }
  }, [forcedScheduleData]);

  useEffect(() => {
    if (scheduleData && showSchedulePreview) {
      let interviewDateRow = {};
      if (scheduleData) {
        const { metaData } = scheduleData;

        const { DateOfInterview, StartTime, Label } = metaData;
        const timeZone = dContext.department.TimeZone;
        interviewDateRow.scheduleName = metaData.Label;
        interviewDateRow.interviewDate = dayjs.tz(`${DateOfInterview || ''} ${StartTime}`, timeZone);
      } else if (row) {
        interviewDateRow.scheduleName = row.Label;
        interviewDateRow.interviewDate = row.MomentDateOfInterview;
      }

      setIsProcessingPDF(true);
      createPDFForSchedule({
        interviewDateRow: interviewDateRow,
        scheduleData,
        columnTracker,
        candidates,
        department: dContext.department,
        PDFOrientation,
        PDFFontSize,
        willGetDataUrl: true,
        callback: (dataURL) => {
          if (dataURL) {
            setSchedulePreviewDataURL(dataURL);
          }
          setIsProcessingPDF(false);
        },
      });
    }
  }, [PDFOrientation, JSON.stringify(scheduleData || {}), PDFFontSize, showSchedulePreview]);

  useEffect(() => {
    if (setIsShowingSchedulePreview) {
      setIsShowingSchedulePreview(showSchedulePreview);
      if (showSchedulePreview) {
        setIsProcessingPDF(true);
      }
    }
  }, [showSchedulePreview]);

  useEffect(() => {
    return () => {
      if (pdfPreviewUrl) {
        URL.revokeObjectURL(pdfPreviewUrl);
      }
    };
  }, [pdfPreviewUrl]);

  useEffect(() => {
    if (row && row.pk_InterviewDate != null) {
      // getScheduleData();
    }
  }, [row]);

  useEffect(() => {
    if (scheduleData && scheduleData.body && scheduleData.body.length > 0) {
      if (isPreparingScheduleData) {
        setIsPreparingScheduleData(!scheduleData.body[0].slot);
      }
    }
  }, [scheduleData]);

  const getQuestions = (callback) => {
    getTokenSilently()
      .then((token) => {
        fetchDataAgnostic(
          'department/questions',
          { pk_Department: dContext.department.pk_Department, pk_Season: dContext.season.pk_Season },
          formatBearerToken(token),
        )
          .then((result) => {
            if (result.data && result.data) {
              callback(result.data);
            } else {
              callback([]);
            }
          })
          .catch((err) => {
            callback([]);
            setIsProcessingPDF(false);
            toast.error('Failed to load questions. Please try again.');
          });
      })
      .catch((err) => {
        checkLoginForError({
          err,
          loginWithRedirect,
          cb: () => {
            callback([]);
            setIsProcessingPDF(false);
            toast.error('Failed to load questions. Please try again.');
          },
        });
      });
  };

  const getCandidatesForDate = (pk_InterviewDate, callback) => {
    getTokenSilently()
      .then((token) => {
        fetchDataAgnostic(
          'department/season/user/scheduledate/candidates',
          {
            pk_Department: department ? department.pk_Department : dContext.department.pk_Department,
            pk_Season: dContext.season.pk_Season,
            pk_InterviewDate,
            allCandidatesForDate: 1,
            mode: 'Evaluation',
          },
          formatBearerToken(token),
        )
          .then((res) => {
            callback(Object.values(res.data));
          })
          .catch((err) => {
            setIsProcessingPDF(false);
            toast.error('Failed to load candidates. Please try again.');
          });
      })
      .catch((err) => {
        checkLoginForError({
          err,
          loginWithRedirect,
          cb: () => {
            setIsProcessingPDF(false);
            toast.error('Failed to load candidates. Please try again.');
          },
        });
      });
  };

  const getScheduleData = (callback) => {
    setIsPreparingScheduleData(true);
    getTokenSilently()
      .then((token) => {
        fetchDataAgnostic(
          'department/season/interviewDate',
          {
            pk_Department: dContext.department.pk_Department,
            pk_Season: dContext.season.pk_Season,
            pk_InterviewDate: scheduleID != null ? parseInt(scheduleID) : row.pk_InterviewDate,
          },
          formatBearerToken(token),
        )
          .then((res) => {
            if (res.data.metaData == null || res.data.metaData.StartDateAndTime == null) {
              setSchedulePreviewDataURL(null);
            } else {
              setScheduleData(res.data);
            }

            if (callback) {
              callback(res.data);
            }
          })
          .catch((err) => {
            if (callback) {
              callback(null);
            }
            setSchedulePreviewDataURL(null);
            setIsPreparingScheduleData(false);
            setIsProcessingPDF(false);
            toast.error('Failed to load schedule data. Please try again.');
          });
      })
      .catch((err) => {
        checkLoginForError({
          err,
          loginWithRedirect,
          cb: () => {
            setIsPreparingScheduleData(false);
            setIsProcessingPDF(false);
            if (callback) {
              callback(null);
            }
            toast.error('Failed to load schedule data. Please try again.');
          },
        });
      });
  };

  const getCandidatesWithSchedules = (pk_InterviewDate, callback) => {
    getTokenSilently()
      .then((token) => {
        fetchDataAgnostic(
          'schedule/season/interviewDate/candidates',
          {
            pk_Department: department ? department.pk_Department : dContext.department.pk_Department,
            pk_Season: dContext.season.pk_Season,
            pk_InterviewDate,
            // allCandidatesForDate: 1,
            // mode: dContext.season.EnablePrescreenMode ? 'Prescreen' : 'Evaluation',
          },
          formatBearerToken(token),
        )
          .then((res) => {
            callback(res.data);
          })
          .catch((err) => {
            setIsProcessingPDF(false);
            toast.error('Failed to load candidate schedules. Please try again.');
          });
      })
      .catch((err) => {
        checkLoginForError({
          err,
          loginWithRedirect,
          cb: () => {
            setIsProcessingPDF(false);
            toast.error('Failed to load candidate schedules. Please try again.');
          },
        });
      });
  };

  const getUsersWithSchedules = (pk_InterviewDate, callback) => {
    getTokenSilently()
      .then((token) => {
        fetchDataAgnostic(
          'department/season/interviewDate/user/schedules',
          {
            pk_Department: department ? department.pk_Department : dContext.department.pk_Department,
            pk_InterviewDate,
          },
          formatBearerToken(token),
        )
          .then((res) => {
            callback(res.data);
          })
          .catch((err) => {
            setIsProcessingPDF(false);
            toast.error('Failed to load evaluator schedules. Please try again.');
          });
      })
      .catch((err) => {
        checkLoginForError({
          err,
          loginWithRedirect,
          cb: () => {
            setIsProcessingPDF(false);
            toast.error('Failed to load evaluator schedules. Please try again.');
          },
        });
      });
  };

  const getDepartmentDataTypes = (callback) => {
    getTokenSilently()
      .then((token) => {
        fetchDataAgnostic(
          'department/dataTypes',
          { pk_Department: dContext.department.pk_Department },
          formatBearerToken(token),
        )
          .then((res) => {
            callback(res.data);
          })
          .catch((err) => {
            // Silent fail - this is not user-initiated and has fallback behavior
            callback([]);
          });
      })
      .catch((err) => {
        checkLoginForError({
          err,
          loginWithRedirect,
          cb: () => {
            callback([]);
          },
        });
      });
  };

  const downloadCandidatesCSV = () => {
    setIsDownlaodingCandidates(true);

    getCandidatesForDate(scheduleID ? scheduleID : row ? row.pk_InterviewDate : null, (validCandidates) => {
      setIsDownlaodingCandidates(false);
      const newCSVData = [
        [
          'AAMC ID',
          'SFMatch ID',
          'NRMP ID',
          'Last Name',
          'Middle Name',
          'First Name',
          'Medical School of Graduation',
          'Phone Number',
          'Email Address',
        ],
      ];

      validCandidates.forEach((candidate) => {
        const {
          AAMCID,
          SFMatchID,
          NRMPID,
          pk_InterviewDate,
          LastName,
          MiddleName,
          FirstName,
          MedicalSchoolOfGraduation,
          Phone,
          Email,
        } = candidate;

        // if (scheduleID != pk_InterviewDate) {
        //   return;
        // }
        const newRow = [
          AAMCID || '',
          SFMatchID || '',
          NRMPID || '',
          LastName || '',
          MiddleName || '',
          FirstName || '',
          MedicalSchoolOfGraduation || '',
          Phone || '',
          Email || '',
        ];

        newCSVData.push(newRow);
      });
      if (newCSVData.length <= 1) {
        Swal.fire('Error', 'There are no Candidates for this Interview Date. There is nothing to print!', 'error');
        return;
      }

      setCandidateCSVData(newCSVData);
      // setIsProcessingPDF(false);
    });
  };

  const downloadSchedulePDF = () => {
    const containerElement = document.getElementById('scheduleContainer');
    const html = containerElement ? containerElement.outerHTML : null;
    let dateToUse = dayjs();
    const timeZone = dContext.department.TimeZone;
    if (scheduleData) {
      const { metaData } = scheduleData;
      const { DateOfInterview, StartTime } = metaData;
      dateToUse = dayjs.tz(`${DateOfInterview || ''} ${StartTime}`, timeZone);
    } else if (row && row.MomentDateOfInterview) {
      dateToUse = row.MomentDateOfInterview;
    }

    if (html) {
      createPDFForSchedule({
        interviewDateRow: { scheduleName: row.Label, interviewDate: dateToUse },
        scheduleData,
        columnTracker,
        candidates,
        department: dContext.department,
        PDFOrientation,
        PDFFontSize,
      });
    }
  };

  const closePdfPreviewModal = () => {
    setShowPdfPreviewModal(false);
    if (pdfPreviewUrl) {
      URL.revokeObjectURL(pdfPreviewUrl);
    }
    setPdfPreviewUrl(null);
    setPdfPreviewTitle('');
    setPdfPreviewFileName('');
  };

  const getSessionPreviewContextLabel = () => {
    const label = row && row.Label ? row.Label : scheduleData && scheduleData.metaData ? scheduleData.metaData.Label : '';

    let dateLabel = '';
    if (scheduleData && scheduleData.metaData) {
      const { DateOfInterview, StartTime } = scheduleData.metaData;
      const timeZone = dContext.department.TimeZone;
      if (DateOfInterview && StartTime) {
        dateLabel = dayjs.tz(`${DateOfInterview} ${StartTime}`, timeZone).format('MMM DD, YYYY');
      }
    } else if (row && row.MomentDateOfInterview) {
      dateLabel = row.MomentDateOfInterview.format('MMM DD, YYYY');
    }

    if (label && dateLabel) {
      return `${label} (${dateLabel})`;
    }

    return label || dateLabel || 'Session';
  };

  const handlePdfPreviewReady = (title) => {
    return (blobUrl, fileName, err) => {
      setIsProcessingPDF(false);
      setPdfProgress({ current: 0, total: 0 });

      if (err || !blobUrl) {
        return;
      }

      if (pdfPreviewUrl) {
        URL.revokeObjectURL(pdfPreviewUrl);
      }

      setPdfPreviewUrl(blobUrl);
      setPdfPreviewTitle(`${title} - ${getSessionPreviewContextLabel()}`);
      setPdfPreviewFileName(fileName || `${title}.pdf`);
      setShowPdfPreviewModal(true);
    };
  };

  const renderPreviewModal = () => {
    let dateLabel = '';
    if (scheduleData) {
      const { metaData } = scheduleData;
      const { DateOfInterview, StartTime } = metaData;
      const timeZone = dContext.department.TimeZone;
      dateLabel = dayjs.tz(`${DateOfInterview || ''} ${StartTime}`, timeZone).format('MMM DD, YYYY');
    } else if (row && row.MomentDateOfInterview) {
      dateLabel = row.MomentDateOfInterview.format('MMM DD, YYYY');
    }

    return (
      <Modal
        isOpen={showSchedulePreview}
        style={{ maxWidth: '90%', maxHeight: '90%' }}
        zIndex={9999}
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
        }}
      >
        <ModalHeader
          closeButton
          toggle={() => {
            setShowSchedulePreview(!showSchedulePreview);
          }}
        >
          <div style={{ ...style.spacedBetweenRow, width: '85vw' }}>
            <div>
              <div style={{ ...style.simpleRow, alignItems: 'center' }}>
                <div style={{ fontSize: 22, marginTop: 20, fontWeight: 'bold' }}>
                  Schedule - {row.Label} ({dateLabel})
                </div>
                <div style={{ marginLeft: 20 }}>
                  <Label for="pdf_orientation_btn" style={{ fontSize: 12, marginBottom: 0 }}>
                    Orientation
                  </Label>
                  <Input
                    type="select"
                    id="pdf_orientation_btn"
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                    onChange={(e) => {
                      setPDFOrientation(e.target.value);
                    }}
                  >
                    <option value="landscape">Landscape</option>
                    <option value="portrait">Portrait</option>
                  </Input>
                </div>
                <div style={{ marginLeft: 20, width: 100 }}>
                  <Label for="pdf_font_size_btn" style={{ fontSize: 12, marginBottom: 0 }}>
                    Font Size
                  </Label>
                  <Input
                    id="pdf_font_size_btn"
                    type="number"
                    value={PDFFontSize}
                    onChange={(e) => {
                      const newValue = parseInt(e.target.value);
                      if (newValue > 0) setPDFFontSize(newValue);
                    }}
                  />
                </div>
              </div>
            </div>
            <div>
              <Button
                disabled={scheduleData == null}
                color="success"
                id="pdf_download_btn"
                onClick={() => {
                  downloadSchedulePDF();
                }}
              >
                Download
              </Button>
            </div>
          </div>
        </ModalHeader>
        <ModalBody>
          <div
            style={{
              // display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
              overflow: 'scroll',
              height: '80vh',
            }}
          >
            {isProcessingPDF ? (
              // <Spinner color="primary" style={{ marginTop: '30vh', marginLeft: '49%' }} />
              <div style={{ marginTop: '30vh', height: 100 }}>
                {' '}
                <Loading />
              </div>
            ) : schedulePreviewDataURL ? (
              <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <Document
                  file={schedulePreviewDataURL}
                  onLoadSuccess={({ numPages }) => setNumPages(numPages)}
                  onLoadError={(error) => console.error('Error loading PDF:', error)}
                  loading={<Loading />}
                >
                  {numPages &&
                    Array.from(new Array(numPages), (el, index) => (
                      <Page
                        key={`page_${index + 1}`}
                        pageNumber={index + 1}
                        width={Math.min(window.innerWidth * 0.9, 1200)}
                        renderTextLayer={false}
                        renderAnnotationLayer={false}
                      />
                    ))}
                </Document>
              </div>
            ) : (
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                {'No Schedule PDF Data'}
              </div>
            )}

            <div style={{ visibility: 'collapse', height: 0, overflow: 'clip' }}>
              <Schedule
                isEmbedded={true}
                pk_InterviewDate={scheduleID ? parseInt(scheduleID) : row.pk_InterviewDate}
                embeddedRef={scheduleRef}
                setParentScheduleData={setScheduleData}
                setParentColumnTracker={setColumnTracker}
                setParentCandidates={setCandidates}
              />
            </div>
          </div>
        </ModalBody>
      </Modal>
    );
  };

  const renderCandidateCSVDownload = () => {
    if (candidateCSVData && candidateCSVData.length > 0) {
      const dateToUse =
        scheduleData && scheduleData.metaData
          ? dayjs.tz(
              `${scheduleData.metaData.DateOfInterview} ${scheduleData.metaData.StartTime}`,
              dContext.department.TimeZone,
            )
          : row.MomentDateOfInterview;
      return (
        <div style={{ visibility: 'hidden', display: 'none' }}>
          <CSVLink
            data={candidateCSVData}
            ref={candidateCSVDownload}
            target="_blank" rel="noopener noreferrer"
            filename={`${dateToUse.format('MMM. DD YYYY (ddd)')} Candidates.csv`}
          >
            Download
          </CSVLink>
        </div>
      );
    } else {
      return null;
    }
  };

  const renderLoadingModal = () => {
    return (
      <Modal isOpen={isProcessingPDF} centered={true}>
        <ModalBody>
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
            <Loading
              options={{
                labelText: `Processing candidates: ${
                  pdfProgress.total > 0 ? `${pdfProgress.current} / ${pdfProgress.total}` : '. . .'
                }`,
              }}
            />
          </div>
        </ModalBody>
      </Modal>
    );
  };

  const isDisabledButtons = isDownloadingCandidates || isProcessingPDF || isPreparingScheduleData; //|| row.CountOfCandidates <= 0 || row.CountOfCandidates == null;

  const { TimeZone } = dContext.department || {};
  return (
    <div style={style.simpleRow}>
      <div style={{ ...style.simpleColumn, flex: 1 }}>
        <div style={style.simpleRow}>
          <div id="master_schedule_btn_container" style={{ paddingRight: 20, width: '100%' }}>
            <Button
              disabled={!isScheduleInitialized || isDisabledButtons}
              style={{ ...style.genButton, width: '100%' }}
              onClick={() => {
                setShowSchedulePreview(true);
                // downloadSchedulePDF();
              }}
            >
              <div style={{ ...style.spacedBetweenRow, width: '100%' }}>
                <FontAwesomeIcon icon={faCalendarAlt} style={style.buttonIcon} />
                <div style={style.buttonLabel}>Master Schedule</div>
              </div>
            </Button>
          </div>
          <UncontrolledTooltip target="master_schedule_btn_container" placement="top">
            {isScheduleInitialized ? 'View and download master schedule' : 'Schedule not initialized yet.'}
          </UncontrolledTooltip>
        </div>
        <div style={style.simpleRow}>
          <Button
            style={{ ...style.genButton, width: '100%' }}
            disabled={isDisabledButtons}
            onClick={() => {
              setIsProcessingPDF(true);
              console.log('dContext: ', clone(dContext));
              getUsersWithSchedules(
                scheduleID ? scheduleID : row ? row.pk_InterviewDate : null,
                (usersWithSchedules) => {
                  console.log('usersWithSchedules: ', usersWithSchedules);

                  if (usersWithSchedules && usersWithSchedules.length > 0) {
                    const user0 = usersWithSchedules[0];
                    if (user0.body && user0.body[0]) {
                      const StartTime = user0.body[0].StartTime;
                      const startFormatted = dayjs.tz(StartTime, TimeZone).format('hh:mm A');
                      console.log("user 0's first schedule slot's StartTime: ", StartTime);
                      console.log(
                        `user 0's first schedule slot's StartTime formatted in timezone=${TimeZone}: ${startFormatted}`,
                      );
                    }
                  }
                createPDFForEvaluatorSchedule({
                  department: dContext.department,
                  evaluators: usersWithSchedules || [],
                  interviewDate: scheduleData || row,
                  previewCallback: handlePdfPreviewReady('Evaluator Schedules'),
                });
              },
            );
            }}
          >
            <div style={{ ...style.spacedBetweenRow, width: '100%' }}>
              <FontAwesomeIcon icon={faUserEdit} style={style.buttonIcon} />
              <div style={style.buttonLabel}>Evaluator Schedules</div>
            </div>
          </Button>
        </div>

        <div style={style.simpleRow}>
          <Button
            style={{ ...style.genButton, width: '100%' }}
            disabled={isDisabledButtons}
            onClick={() => {
              setIsProcessingPDF(true);
              getCandidatesForDate(scheduleID ? scheduleID : row ? row.pk_InterviewDate : null, (candidatesForDate) => {
                getQuestions((newQuestions) => {
                  createPDFForCandidateEvaluations({
                    department: dContext.department,
                    candidates: candidatesForDate,
                    questions: newQuestions,
                    interviewDate: scheduleData || row,
                    previewCallback: handlePdfPreviewReady('Candidate Evaluations'),
                  });
                });
              });
            }}
          >
            <div style={{ ...style.spacedBetweenRow, width: '100%' }}>
              <FontAwesomeIcon icon={faListUl} style={style.buttonIcon} />
              <div style={style.buttonLabel}>Candidate Evaluations</div>
            </div>
          </Button>
        </div>

        <div style={style.simpleRow}>
          <Button
            style={{ ...style.genButton, width: '100%' }}
            disabled={isDisabledButtons}
            onClick={() => {
              if (scheduleData) {
                setIsProcessingPDF(true);
                getCandidatesForDate(
                  scheduleID ? scheduleID : row ? row.pk_InterviewDate : null,
                  (candidatesForDate) => {
                    createPDFForCandidatesBreakReport({
                      department: dContext.department,
                      candidates: candidatesForDate,
                      interviewDate: scheduleData || row,
                      scheduleData,
                      columnTracker,
                      rowTracker,
                      previewCallback: handlePdfPreviewReady('Candidates Break Report'),
                    });
                  },
                );
              } else {
                setIsProcessingPDF(true);
                getScheduleData((newScheduleData) => {
                  if (newScheduleData) {
                    getCandidatesForDate(
                      scheduleID ? scheduleID : row ? row.pk_InterviewDate : null,
                      (candidatesForDate) => {
                        createPDFForCandidatesBreakReport({
                          department: dContext.department,
                          candidates: candidatesForDate,
                          interviewDate: scheduleData || row,
                          scheduleData: newScheduleData,
                          columnTracker,
                          rowTracker,
                          previewCallback: handlePdfPreviewReady('Candidates Break Report'),
                        });
                      },
                    );
                  } else {
                    setIsProcessingPDF(false);
                  }
                });
              }
            }}
          >
            <div style={{ ...style.spacedBetweenRow, width: '100%' }}>
              <FontAwesomeIcon icon={faCoffee} style={style.buttonIcon} />
              <div style={style.buttonLabel}>Candidates Break Report</div>
            </div>
          </Button>

          <div style={{ visibility: 'hidden', width: 0, height: 0 }}>
            <Schedule
              isEmbedded={true}
              pk_InterviewDate={scheduleID ? parseInt(scheduleID) : row.pk_InterviewDate}
              embeddedRef={scheduleRef}
              setParentScheduleData={(newScheduleData) => {
                setScheduleData(newScheduleData);
              }}
              setParentColumnTracker={setColumnTracker}
              setParentRowTracker={setRowTracker}
              setParentCandidates={setCandidates}
            />
          </div>
        </div>
      </div>
      <div style={{ ...style.simpleColumn, flex: 1 }}>
        <div style={style.simpleRow}>
          <Button
            style={{ ...style.genButton, width: '100%' }}
            disabled={isDisabledButtons}
            onClick={() => {
              setIsProcessingPDF(true);

              getCandidatesWithSchedules(
                scheduleID ? scheduleID : row ? row.pk_InterviewDate : null,
                (candidatesWithSchedules) => {
                  if (candidatesWithSchedules && candidatesWithSchedules.length > 0) {
                    const candidate0 = candidatesWithSchedules[0];
                    if (candidate0.schedule && candidate0.schedule[0]) {
                      const StartTime = candidate0.schedule[0].StartTime;
                      const startFormatted = dayjs.tz(StartTime, TimeZone).format('hh:mm A');
                    }
                  }

                  createPDFForCandidateSchedule({
                    department: dContext.department,
                    candidates: candidatesWithSchedules,
                    interviewDate: scheduleData || row,
                    previewCallback: handlePdfPreviewReady('Candidate Schedules'),
                  });
                },
              );
            }}
          >
            <div style={{ ...style.spacedBetweenRow, width: '100%' }}>
              <FontAwesomeIcon icon={faCalendarDay} style={style.buttonIcon} />
              <div style={style.buttonLabel}>Candidate Schedules</div>
            </div>
          </Button>
        </div>
        <div style={style.simpleRow}>
          <Button
            disabled={isDisabledButtons}
            style={{ ...style.genButton, width: '100%' }}
            onClick={() => {
              setIsProcessingPDF(true);
              setPdfProgress({ current: 0, total: 0 });
              getCandidatesForDate(scheduleID ? scheduleID : row ? row.pk_InterviewDate : null, (candidates) => {
                setPdfProgress({ current: 0, total: candidates.length });
                createPDFForCandidateBadges({
                  department: dContext.department,
                  candidates,
                  interviewDate: scheduleData || row,
                  onProgress: (progress) => {
                    setPdfProgress(progress);
                  },
                  previewCallback: handlePdfPreviewReady('Candidate Badges (5390)'),
                });
              });
            }}
          >
            <div style={{ ...style.spacedBetweenRow, width: '100%' }}>
              <FontAwesomeIcon icon={faIdCardAlt} style={style.buttonIcon} />
              <div style={style.buttonLabel}>Candidate Badges (5390)</div>
            </div>
          </Button>
        </div>

        <div style={style.simpleRow}>
          <Button
            disabled={isDisabledButtons}
            style={{ ...style.genButton, width: '100%' }}
            onClick={() => {
              setIsProcessingPDF(true);
              setPdfProgress({ current: 0, total: 0 });
              getCandidatesForDate(scheduleID ? scheduleID : row ? row.pk_InterviewDate : null, (candidates) => {
                setPdfProgress({ current: 0, total: candidates.length });
                createPDFForCandidateBadges2({
                  department: dContext.department,
                  candidates,
                  interviewDate: scheduleData || row,
                  onProgress: (progress) => {
                    setPdfProgress(progress);
                  },
                  previewCallback: handlePdfPreviewReady('Candidate Badges (5834)'),
                });
              });
            }}
          >
            <div style={{ ...style.spacedBetweenRow, width: '100%' }}>
              <FontAwesomeIcon icon={faIdCardAlt} style={style.buttonIcon} />
              <div style={style.buttonLabel}>Candidate Badges (5834)</div>
            </div>
          </Button>
        </div>

        <div style={style.buttonLabel}>When Printing Avery Templates, use "Actual Size" option.</div>
      </div>

      <div style={{ ...style.simpleColumn, flex: 1 }}>
        <div style={style.simpleRow}>
          <Button
            style={{ ...style.genButton, width: '100%' }}
            disabled={isDisabledButtons}
            onClick={() => {
              setIsProcessingPDF(true);
              getCandidatesForDate(scheduleID ? scheduleID : row ? row.pk_InterviewDate : null, (candidates) => {
                createPDFForCandidateFaces({
                  department: dContext.department,
                  candidates,
                  interviewDate: scheduleData || row,
                  previewCallback: handlePdfPreviewReady('Face Sheet Grid'),
                });
              });
            }}
          >
            <div style={{ ...style.spacedBetweenRow }}>
              <FontAwesomeIcon icon={faUserAlt} style={style.buttonIcon} />
              <div style={style.buttonLabel}>Face Sheet Grid</div>
            </div>
          </Button>
        </div>

        <div style={style.simpleRow}>
          <Button
            style={{ ...style.genButton, width: '100%' }}
            disabled={isDisabledButtons}
            onClick={() => {
              setIsProcessingPDF(true);

              getCandidatesForDate(scheduleID ? scheduleID : row ? row.pk_InterviewDate : null, (candidates) => {
                createPDFForCandidateFacesWithNotes({
                  department: dContext.department,
                  candidates,
                  interviewDate: scheduleData || row,
                  activeFields: dataTypes || [],
                  previewCallback: handlePdfPreviewReady('Face Sheet With Notes'),
                });
              });
            }}
          >
            <div style={{ ...style.spacedBetweenRow }}>
              <FontAwesomeIcon icon={faUserAlt} style={style.buttonIcon} />
              <div style={style.buttonLabel}>Face Sheet With Notes</div>
            </div>
          </Button>
        </div>

        <div style={style.simpleRow}>
          <Button
            style={{ ...style.genButton, width: '100%' }}
            disabled={isDisabledButtons}
            onClick={() => {
              setIsProcessingPDF(true);
              getCandidatesForDate(scheduleID ? scheduleID : row ? row.pk_InterviewDate : null, (candidates) => {
                createPDFForCandidateFactCards({
                  department: dContext.department,
                  candidates,
                  interviewDate: scheduleData || row,
                  previewCallback: handlePdfPreviewReady('Fact Sheet'),
                });
              });
            }}
          >
            <div style={{ ...style.spacedBetweenRow }}>
              <FontAwesomeIcon icon={faAddressCard} style={style.buttonIcon} />
              <div style={style.buttonLabel}>Fact Sheet</div>
            </div>
          </Button>
        </div>

        <div style={style.simpleRow}>
          <Button
            disabled={row == null || row.CountOfCandidates <= 0 || isDisabledButtons}
            style={{ ...style.genButton, width: '100%' }}
            onClick={() => {
              downloadCandidatesCSV();
            }}
          >
            <div style={{ ...style.spacedBetweenRow, width: '100%' }}>
              <FontAwesomeIcon icon={faUsers} style={style.buttonIcon} />
              <div style={style.buttonLabel}>Candidate List (Excel CSV)</div>
            </div>
          </Button>
        </div>
      </div>
      {renderCandidateCSVDownload()}
      <PdfPreviewModal
        isOpen={showPdfPreviewModal}
        title={pdfPreviewTitle}
        pdfUrl={pdfPreviewUrl}
        fileName={pdfPreviewFileName}
        onClose={closePdfPreviewModal}
      />
      {renderPreviewModal()}
      {renderLoadingModal()}
    </div>
  );
};

export default PrintDropDown;
